import { render, staticRenderFns } from "./Wishlist.vue?vue&type=template&id=d8b95fe6&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"
import style0 from "./Wishlist.vue?vue&type=style&index=0&id=d8b95fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b95fe6",
  null
  
)

export default component.exports